export default __webpack_public_path__ + "static/accredited-debt-relief-header-4d93c5426ae3ca42b195e16040eb08b2.png";